import { useState } from "react";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";
import { X, Ban } from "lucide-react";

export default function CancelModal({ circuit, onClose, onDone }) {
  const today = new Date().toISOString().slice(0, 10);
  const [form, setForm] = useState({ cancellation_date: today, reason: "", remarks: "" });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const field = "mt-1 w-full h-10 px-3 rounded-lg border border-slate-300 focus:border-blue-500 outline-none text-sm";

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/circuits/${circuit.id}/cancel`, form);
      toast.success("Cancellation recorded — moved to Vendor Disconnection Pending");
      onDone?.();
      onClose();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="cancel-modal">
        <div className="flex items-start justify-between p-5 border-b">
          <div>
            <h3 className="font-head font-bold text-lg flex items-center gap-2"><Ban className="text-red-600" size={20} /> Customer Cancellation</h3>
            <p className="text-sm text-slate-500 mt-0.5">{circuit.customer_name} · {circuit.internal_circuit_id}</p>
          </div>
          <button onClick={onClose} className="text-slate-400"><X /></button>
        </div>
        <div className="p-5 space-y-4">
          <div className="text-sm bg-amber-50 border border-amber-200 text-amber-800 rounded-lg px-3 py-2">
            Future renewals stop immediately. The circuit stays under <b>Vendor Disconnection Pending</b> until vendor closure is confirmed — it is not deleted.
          </div>
          <div>
            <label className="text-sm font-medium">Customer Cancellation Date</label>
            <input type="date" value={form.cancellation_date} onChange={(e) => set("cancellation_date", e.target.value)} className={field} data-testid="cancel-date" />
          </div>
          <div>
            <label className="text-sm font-medium">Reason</label>
            <input value={form.reason} onChange={(e) => set("reason", e.target.value)} className={field} placeholder="e.g. Contract terminated" data-testid="cancel-reason" />
          </div>
          <div>
            <label className="text-sm font-medium">Remarks</label>
            <textarea value={form.remarks} onChange={(e) => set("remarks", e.target.value)} rows={2} className="mt-1 w-full px-3 py-2 rounded-lg border border-slate-300 outline-none text-sm" />
          </div>
        </div>
        <div className="p-5 border-t flex justify-end gap-3">
          <button onClick={onClose} className="px-4 h-10 rounded-lg border text-sm font-medium">Back</button>
          <button onClick={submit} disabled={saving} data-testid="cancel-submit" className="px-5 h-10 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-semibold disabled:opacity-60">Confirm Cancellation</button>
        </div>
      </div>
    </div>
  );
}
